/**
 * @generated SignedSource<<a5390c5a3e08c06ce86a6a9f1c243024>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateAccountFeeOrCreditInput = {
  amount: number;
  block: number;
  clientMutationId?: string | null | undefined;
  profileId: string;
  startingYear: number;
};
export type UpdateAccountFeeOrCreditMutation$variables = {
  input: UpdateAccountFeeOrCreditInput;
};
export type UpdateAccountFeeOrCreditMutation$data = {
  readonly updateAccountFeeOrCredit: {
    readonly accountFeeOrCredit: {
      readonly amount: number | null | undefined;
      readonly id: string;
    } | null | undefined;
    readonly errors: any | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type UpdateAccountFeeOrCreditMutation = {
  response: UpdateAccountFeeOrCreditMutation$data;
  variables: UpdateAccountFeeOrCreditMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateAccountFeeOrCreditPayload",
    "kind": "LinkedField",
    "name": "updateAccountFeeOrCredit",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AccountFeeOrCreditNode",
        "kind": "LinkedField",
        "name": "accountFeeOrCredit",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateAccountFeeOrCreditMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateAccountFeeOrCreditMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "28ba6c4f4376dcab472fba77e1e8e007",
    "id": null,
    "metadata": {},
    "name": "UpdateAccountFeeOrCreditMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateAccountFeeOrCreditMutation(\n  $input: UpdateAccountFeeOrCreditInput!\n) {\n  updateAccountFeeOrCredit(input: $input) {\n    success\n    errors\n    accountFeeOrCredit {\n      id\n      amount\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc5f45c39f45cfe9d95fbfb9e170149e";

export default node;
